import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';
import { environment } from '../environment/environment';

export const roleGuard = (allowedRoles: string[]) =>
  createAuthGuard(async (route, state, { authenticated, grantedRoles, keycloak }) => {
    if (!environment.roleGuardEnabled) {
      return true;
    }

    if (!authenticated) {
      await keycloak.login();
      return false;
    }

    const router = inject(Router);
    const roles = grantedRoles.resourceRoles[environment.keycloak.clientId] ?? [];
    const hasRole = allowedRoles.length === 0 || allowedRoles.some((role) => roles.includes(role));

    return hasRole ? true : router.parseUrl('/unauthorized');
  });
